import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import type Employee from 'modules/employees/store/models/Employee'

export const ALL_TYPES = {
  adherence: 'adherence',
  contract: 'contract',
  custom: 'custom',
  custom_company: 'custom_company',
  default: 'default',
  expenses_company: 'expenses_company',
  expenses_employee: 'expenses_employee',
  hiring: 'hiring',
  id_document: 'id-document',
  modelo_145: 'modelo-145',
  novation: 'novation',
  payment: 'payment',
  payslip: 'payslip',
  es_payslip: 'Nóminas',
  fr_payslip: 'Bulletins de salaires',
  sick_leave: 'sick-leave',
  social_insurance: 'social_insurance',
  tax: 'tax',
  payslip_summary: 'payslip_summary',
  es_payslip_summary: 'Resúmenes de nómina',
  fr_payslip_summary: 'Résumé Paie',
  es_payroll_export: 'Descargas de nómina',
  fr_payroll_export: 'Données sur les salaires',
  readonly: 'readonly',
  readonly_employee: 'readonly_employee',
  payroll_company: 'payroll_company',
  training_certificates: 'training_certificates',
}

export const PAYROLL_RESULT_FOLDER_IDENTIFIER = [
  'payslip_summaries_es',
  'payslip_summaries_fr',
  'payslip_summaries_mx',
  'payslip_summaries_other',
]

export const PAYROLL_PAYSLIP_FOLDER_IDENTIFIER = ['payslips_es', 'payslips_fr', 'payslips_other']

interface IFolder {
  [key: string]: any
}

class Folder extends Model<IFolder> {
  static urlRoot() {
    return '/folders'
  }

  constructor(attr: IFolder = {}) {
    super(attr)
    makeObservable(this, {
      type: computed,
      isExpensesType: computed,
      isReadonly: computed,
      showOnly: computed,
    })
  }

  get type(): string {
    return this.attributes.type
  }

  get isExpensesType(): boolean {
    switch (this.type) {
      case ALL_TYPES.expenses_company:
      case ALL_TYPES.expenses_employee:
        return true

      default:
        return false
    }
  }

  get isReadonly(): boolean {
    return this.attributes.is_readonly
  }

  get isCompany(): boolean {
    return this.attributes.is_company
  }

  get showOnly(): boolean {
    return (
      this.attributes.type === ALL_TYPES.readonly ||
      this.attributes.type === ALL_TYPES.readonly_employee
    )
  }

  isWritableEmployeeFolder(employee: Employee): boolean {
    return (
      !this.showOnly && (employee.policy.can('readDocuments') || this.attributes.manage_permission)
    )
  }

  isReadableEmployeeFolder(employee: Employee): boolean {
    return employee.policy.can('readDocuments') || this.attributes.manage_permission
  }
}

export default Folder
